/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Saved_ToastInputs */



/**
* | output |
* | --- |
* | "Style guide changes saved" |
*
* @param {Style_Guide_Manager_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_saved_toast = /** @type {((inputs?: Style_Guide_Manager_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifications du guide de style enregistrees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen am Styleguide gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche alla guida di stile salvate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранены изменения в руководстве по стилю.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambios en la guía de estilo guardados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南更改已保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドの変更を保存しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड में किए गए बदलाव सहेज लिए गए हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterações no guia de estilo salvas")
	return /** @type {LocalizedString} */ ("Style guide changes saved")
});